import { Capacitor } from "@capacitor/core";

const ANDROID_RESTRICTED_PAGES = new Set(["saglik", "cocuk", "ozelTakvim"]);
const ANDROID_RESTRICTED_MODULES = new Set([
  "health",
  "healthrecords",
  "medicine",
  "medicines",
  "children",
  "childrecords",
  "cycle",
  "ozeltakvim",
]);

const normalizeKey = (value) =>
  String(value || "").trim().toLocaleLowerCase("tr-TR").replace(/[^a-z0-9çğıöşü]/g, "");

export const isAndroidPlatform = () => Capacitor.getPlatform() === "android";

// MADDE 1 (iOS klavye telafisi) için: yalnızca gerçek iOS native kabında true.
export const isIOSPlatform = () => Capacitor.getPlatform() === "ios";

export const isNativePlatform = () => Capacitor.isNativePlatform();

export const areAndroidHealthFeaturesDisabled = () => isAndroidPlatform();

export const isAndroidRestrictedPage = (pageKey) =>
  areAndroidHealthFeaturesDisabled() && ANDROID_RESTRICTED_PAGES.has(normalizeKey(pageKey));

export const isAndroidRestrictedModule = (moduleKey) =>
  areAndroidHealthFeaturesDisabled() && ANDROID_RESTRICTED_MODULES.has(normalizeKey(moduleKey));

export const normalizeAndroidPage = (pageKey, fallback = "ana") =>
  isAndroidRestrictedPage(pageKey) ? fallback : pageKey;

export const isAndroidRestrictedNotification = (notification = {}) => {
  if (!areAndroidHealthFeaturesDisabled()) return false;

  const values = [
    notification.type,
    notification.bildirimTipi,
    notification.bildirimType,
    notification.tip,
    notification.module,
    notification.modul,
    notification.source,
    notification.kaynak,
    notification.data?.type,
    notification.data?.module,
    notification.data?.source,
    notification.data?.kaynak,
  ];

  if (values.some(isAndroidRestrictedModule)) return true;
  if (values.some((value) => normalizeKey(value) === "assistant")) return true;

  try {
    const url = new URL(notification.url || notification.data?.url || "", window.location.origin);
    return isAndroidRestrictedPage(url.searchParams.get("pushPage"));
  } catch {
    return false;
  }
};
